<template>
  <v-card flat class="site-title">
    <transition name="slide-fade">
      <v-card-title v-if="showTitle" class="page-title"
        >Angemeldet als: {{ name }}</v-card-title
      >
    </transition>
    <div class="id-search-wrapper">
      <LinkNavigator />
    </div>
  </v-card>
  <v-card flat class="site-wrapper">
    <div class="load-intercom-btn">
      <v-btn
        variant="elevated"
        prepend-icon="mdi-information"
        @click="loadOpenIntercomTickets"
        :loading="loading"
        rounded="lg"
        >Aktualisiere Intercom</v-btn
      >
    </div>
    <v-row>
      <v-col cols="12" sm="4">
        <v-list
          class="load-intercom-tickets-wrapper"
          elevation="3"
          v-if="assignedOpenTickets"
        >
          <v-list-subheader class="load-intercom-tickets-subheader"
            >Alle dir zugewiesenen Tickets ({{
              assignedOpenTickets.length
            }})</v-list-subheader
          >
          <v-divider class="medium-divider"></v-divider>
          <v-list-item
            v-for="ticket in assignedOpenTickets"
            :key="ticket.id"
            class="load-intercom-button-group"
          >
            <div class="button-wrapper">
              <v-btn
                class="ticket-button text-none"
                target="_blank"
                variant="outlined"
                color="#17100e"
                prepend-icon="mdi-information"
                :href="`https://app.intercom.com/a/inbox/lios09xl/inbox/shared/all/conversation/${ticket.conversation_id}`"
              >
                {{ ticket.author_name }}
              </v-btn>
              <v-btn
                class="agency-button gradient-color-primary"
                @click="openAgencyDialog(ticket)"
                append-icon="mdi-open-in-new"
                >Agentur
              </v-btn>
            </div>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col cols="12" sm="4">
        <v-list
          class="load-intercom-tickets-wrapper"
          elevation="3"
          v-if="unassignedOpenTickets"
        >
          <v-list-subheader class="load-intercom-tickets-subheader"
            >Alle nicht zugewiesenen Tickets ({{
              unassignedOpenTickets.length
            }})</v-list-subheader
          >
          <v-divider class="medium-divider"></v-divider>
          <v-list-item v-for="ticket in unassignedOpenTickets" :key="ticket.id">
            <div class="button-wrapper">
              <v-btn
                class="ticket-button text-none"
                target="_blank"
                variant="outlined"
                prepend-icon="mdi-information"
                :href="`https://app.intercom.com/a/inbox/lios09xl/inbox/shared/all/conversation/${ticket.conversation_id}`"
              >
                {{ ticket.author_name }}
              </v-btn>
              <v-btn
                class="agency-button gradient-color-primary"
                @click="openAgencyDialog(ticket)"
                append-icon="mdi-open-in-new"
                >Agentur
              </v-btn>
            </div>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col cols="12" sm="4">
        <v-list
          class="load-intercom-tickets-wrapper"
          elevation="3"
          v-if="allOpenTickets"
        >
          <v-list-subheader class="load-intercom-tickets-subheader"
            >Alle offenen Tickets ({{
              allOpenTickets.length
            }})</v-list-subheader
          >
          <v-divider class="medium-divider"></v-divider>
          <v-list-item v-for="ticket in allOpenTickets" :key="ticket.id">
            <div class="button-wrapper">
              <v-btn
                class="ticket-button text-none"
                target="_blank"
                variant="outlined"
                prepend-icon="mdi-information"
                :href="`https://app.intercom.com/a/inbox/lios09xl/inbox/shared/all/conversation/${ticket.conversation_id}`"
              >
                {{ ticket.author_name }}
              </v-btn>
              <v-btn
                class="agency-button gradient-color-primary"
                @click="openAgencyDialog(ticket)"
                append-icon="mdi-open-in-new"
                >Agentur
              </v-btn>
            </div>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-card>
  <AgencyDialog
    v-if="selectedAgency.external_id"
    :agencyId="selectedAgency.external_id"
    v-model:agencyDialog="agencyDialog"
  ></AgencyDialog>
</template>

<script>
import AgencyDialog from "@/components/AgencyDialog.vue";
import LinkNavigator from "@/support/supportHelpers/LinkNavigator.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    AgencyDialog,
    LinkNavigator,
  },
  data() {
    return {
      agencyDialog: false,
      selectedAgency: {},
      showTitle: false,
    };
  },
  computed: {
    ...mapState("loginAndOut", ["name"]),
    ...mapState("admin", [
      "loading",
      "allOpenTickets",
      "intercomId",
      "assignedOpenTickets",
      "unassignedOpenTickets",
    ]),
  },
  methods: {
    ...mapActions("admin", [
      "fetchAllOpenTickets",
      "fetchIntercomId",
      "fetchAgencyByEmail",
    ]),
    async loadOpenIntercomTickets() {
      await this.fetchIntercomId();
      await this.fetchAllOpenTickets();
    },
    async openAgencyDialog(ticket) {
      const foundAgency = await this.fetchAgencyByEmail(ticket.author_email);
      setTimeout(() => {
        this.selectedAgency = foundAgency;
        this.agencyDialog = true;
      }, 1000);
      this.$store.dispatch("agency/setDialogReturnRoute", this.$route.fullPath);
      this.$router.push({
        name: "agency",
        params: { agencyId: foundAgency._id },
      });
    },
  },
  mounted() {
    this.showTitle = true;
  },
  created() {
    this.loadOpenIntercomTickets();
  },
};
</script>

<style lang="scss" scoped>
.load-intercom-btn {
  margin-bottom: 20px;
}

.load-intercom-tickets-wrapper {
  background-color: white;
  border-radius: 12px;
  padding: 12px;

  @media screen and (max-width: 600px) {
    padding: 4px;
  }
}

.load-intercom-tickets-subheader {
  font-weight: 600;
  font-size: 18px;

  @media screen and (max-width: 600px) {
    font-size: 16px;
  }
}

.ticket-button {
  width: 100%;
  margin-bottom: 4px;
}

.agency-button {
  width: 100%;
}

.button-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid rgb(196, 196, 196);
  border-radius: 12px;
  padding: 8px;
  background-color: #f9fafb;
  margin-bottom: 12px;
}
.support-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.id-search-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
  max-width: 33%;
  @media screen and (max-width: 600px) {
    max-width: 100%;
    
  }
}

.search-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
  padding: 8px 24px;
  border: 1px solid rgb(196, 196, 196);
  border-radius: 12px;
  background-color: #F2F2F2;
}

.column-wrapper {
  display: flex;
  flex-direction: column;
}

.search-field {
  width: 100%;
  height: 40px;
}
</style>

